import * as React from 'react';
import { HeroBody, Container, Columns, Column, HeroFooter, HeroHeader } from 'bloomer';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

import HeaderBar from '../../components/HeaderBar/HeaderBar';
import FooterBar from '../../components/FooterBar/FooterBar';
import LeftMenu from '../../components/LeftMenu/LeftMenu';
import { getCurrentAppLang } from '../../helpers/util';

type LayoutProps = {
  isAuthenticated?: boolean;
  children?: React.ReactNode;
};

class Layout extends React.Component<LayoutProps> {

  render() {
    const { isAuthenticated } = this.props;
    return (
      <div key={getCurrentAppLang()} >
        <Columns style={{ margin: 0, padding: 0 }}>
          {isAuthenticated ? <MenuColumn isSize={{ mobile: 'full', desktop: 'narrow' }} >
            <LeftMenu />
          </MenuColumn> : null}
          <Column isSize={{ mobile: 'full' }}>
            <HeroHeader>
              <HeaderBar />
            </HeroHeader>

            <HeroBody style={{ padding: 0 }}>
              <Container isFluid style={{ padding: 0 }}>
                {this.props.children}
              </Container>
            </HeroBody>

            <HeroFooter>
              {!isAuthenticated ? <FooterBar /> : undefined}
            </HeroFooter>

          </Column>
        </Columns>
      </ div>
    );
  }
}

const MenuColumn = styled(Column)`
    padding-bottom: 0;
    background: ${colors.purple};
    min-height: 100vh;
`;

export default Layout;